<template>
  <div>
    <h1 class="admin-title">Users</h1>
    <div class="admin-container" style="position:relative;">
      <el-button style="top:-60px;right:0" type="default" class="export-btn" @click="csvExport">Export</el-button>
      <data-tables :search-def="searchDef" :data="allUsers" v-loading="loading">
        <el-table-column label="Name" sortable="custom">
          <template scope="scope">{{scope.row.firstName}} {{scope.row.lastName}}</template>
        </el-table-column>

        <el-table-column label="Email" sortable="custom">
          <template scope="scope">{{scope.row.email}}</template>
        </el-table-column>

        <el-table-column label="GYM" sortable="custom">
          <template scope="scope">{{scope.row.where}}</template>
        </el-table-column>

        <el-table-column label="Registered" sortable="custom">
          <template scope="scope">{{ formatDate(scope.row.createdAt) }}</template>
        </el-table-column>

        <el-table-column label="DOB" sortable="custom">
          <template scope="scope">{{scope.row.dob}}</template>
        </el-table-column>

        <el-table-column label="Plans" sortable="custom">
          <template scope="scope">
            <p style="margin:0;" v-for="(plan, index) in scope.row.selectedPlans" :key="index">
              <span v-if="plan">{{plan.name}}</span>
            </p>
          </template>
        </el-table-column>

        <el-table-column label="Actions" min-width="100px">
          <template scope="scope">
            <el-button type="default" size="mini" @click="openTemplateModal(scope.row.objectId)">
              <i class="fa fa-paper-plane"></i>
            </el-button>
            <el-button type="default" size="mini" @click="openPasswordModal(scope.row.objectId)">
              <i class="fa fa-unlock-alt"></i>
            </el-button>
            <el-button type="default" size="mini" @click="openStripe(scope.row.objectId)">
              <i class="fa fa-credit-card"></i>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="mini"
              placeholder="Type to search"/>
          </template>
          <template scope="scope">
            <el-button type="default" size="mini" @click="sendConfirmation(scope.row)">
                Resend Confirmation Email
            </el-button>
          </template>
        </el-table-column>
      </data-tables>
    </div>
    <el-dialog title="Password Reset" :visible.sync="passwordDialogVisible">
      <h3>Reset password for: {{currUserName}}</h3>
      <el-form :model="form">
        <el-form-item label="Password">
          <el-input
            placeholder="Set a password for this user."
            v-model="form.password"
            type="password"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="passwordDialogVisible = false">Cancel</el-button>
        <el-button :loading="savingPassword" type="primary" @click="setNewPassword">Save</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Send RP Templae" :visible.sync="templateDialogVisible">
      <h3>Re-Send RP Template to: {{currUserName}}</h3>
      <el-form :model="template">
        <el-form-item label>
          <el-select v-model="template.type" placeholder="Template Type">
            <el-option key="draft" label="Basic" value="healthy"></el-option>
            <el-option key="status" label="Advanced" value="diet"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="templateDialogVisible = false">Cancel</el-button>
        <el-button v-show="!sendingTemplate" type="primary" @click="sendRPTemplate">Send</el-button>
        <el-button v-show="sendingTemplate" :loading="true" type="primary">Send</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import converter from "json-2-csv";
import moment from "moment";
const Json2csvParser = require("json2csv").Parser;
export default {
  name: "users",
  data() {
    return {
      search: '',
      tableData: [{
          date: '2016-05-02',
          name: 'John Smith',
          address: 'No.1518,  Jinshajiang Road, Putuo District'
        }, {
          date: '2016-05-04',
          name: 'John Smith',
          address: 'No.1518,  Jinshajiang Road, Putuo District'
        }, {
          date: '2016-05-01',
          name: 'John Smith',
          address: 'No.1518,  Jinshajiang Road, Putuo District'
        }],
      loading: true,
      form: {
        password: null
      },
      savingPassword: false,
      sendingTemplate: false,
      template: {
        type: "healthy"
      },
      currentUser: null,
      currUserName: null,
      titles: [
        {
          prop: "id",
          label: "ID"
        },
        {
          prop: "firstName",
          label: "First Name"
        },
        {
          prop: "lastName",
          label: "Last Name"
        },
        {
          prop: "email",
          label: "Email"
        },
        {
          prop: "where",
          label: "Where"
        },
        {
          prop: "createdAt",
          label: "Registered"
        },
        {
          prop: "goal",
          label: "Goal",
          visible: false
        }
      ],
      users: [],
      templateDialogVisible: false,
      passwordDialogVisible: false,
      savingData: false,
      searchDef: {
        props: ["firstName", "lastName", "email", "where"],
        inputProps: {
          placeholder: "Search"
        }
      }
    };
  },

  mounted: function() {
    var user = Parse.User.current();
    if(!user.get('isSuperAdmin')){
      this.$router.push('/admin-panel/voting')
    }
    this.$nextTick(function() {
      this.getUsers();
    });
  },

  computed: {
    allUsers () {
      return this.users.filter(u => u.email.indexOf(this.search)!==-1);
    }
  },
  methods: {
    formatDate: function(d) {
      return moment(d).format("MM-DD-YY");
    },
    // formatDateOfBirth: function(user) {
    //   return moment(
    //     user.dobMonth + "-" + user.dobDay + "-" + user.dobYear
    //   ).format("MM-DD-YYYY");
    // },
    sendConfirmation (user) {
      Parse.Cloud.run("reSendConfirmation", {
        user_id: user.objectId,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
      }).then(res => {
        console.log(res);
        this.$message({
          type: 'success',
          message: `Confirmation sent to ${user.email}`,
        })
      }).catch(err => {
        console.log(err);
      })
    },
    openStripe: function(id) {
      var _this = this;
      var user = _this.getUserById(id);
      window.open("https://dashboard.stripe.com/customers/" + user.stripeId);
    },
    getUserById: function(id) {
      var _this = this;
      console.log("id", id);
      console.log(_this.users[0]);
      var found = _.find(_this.users, function(u) {
        return u.objectId == id;
      });
      console.log(found);
      return found;
    },
    setNewPassword: function() {
      var _this = this;
      var payload = {
        id: this.currentUser.objectId,
        password: this.form.password
      };

      Parse.Cloud.run("AdminChangePassword", payload)
        .then(function(saved) {
          _this.savingPassword = false;
          _this.currentUser = null;
          _this.passwordDialogVisible = false;
          _this.form.password = null;
          _this.$message({
            type: "success",
            message: "Password Updated!"
          });
        })
        .catch(function(err) {
          console.log(err);
          _this.savingPassword = false;
          _this.$message({
            type: "error",
            message: "Something went wrong. Tell Juan."
          });
        });
    },
    sendRPTemplate () {
      this.sendingTemplate = true;
      var payload = {
        email: this.currentUser.email,
        type: this.template.type
      };
      Parse.Cloud.run("reSendRPTemplate", payload).then(resp => {
          this.sendingTemplate = false;
          this.currentUser = null;
          this.templateDialogVisible = false;
          this.$message({
            type: "success",
            message: "Template Sent!"
          });
        }).catch(err => {
          console.log(err);
          this.sendingTemplate = false;
          this.$message({
            type: "error",
            message: "Something went wrong. Tell Juan."
          });
        });
    },
    openPasswordModal(id) {
      this.currentUser = this.getUserById(id);
      this.currUserName = this.currentUser.firstName + " " + this.currentUser.lastName;
      this.passwordDialogVisible = true;
    },
    openTemplateModal(id) {
      this.currentUser = this.getUserById(id);
      this.currUserName = this.currentUser.firstName + " " + this.currentUser.lastName;
      this.templateDialogVisible = true;
    },
    csvExport: function() {
      var userList = [];
      for (var i = 0; i < this.users.length; i++) {
        userList.push({
          "First Name": this.users[i].firstName,
          "Last Name": this.users[i].lastName,
          Email: this.users[i].email,
          Gender: this.users[i].gender,
          DOB: this.users[i].dob ? moment(this.users[i].dob).format("MM-DD-YYYY") : '',
          Gym: this.users[i].where,
          Registered: moment(this.users[i].createdAt).format("MM-DD-YYYY"),
          "Stripe ID": this.users[i].stripeId,
          Stripe:
            "https://dashboard.stripe.com/customers/" + this.users[i].stripeId
        });
      }
      const Json2csvParser = require("json2csv").Parser;
      const fields = [
        "First Name",
        "Last Name",
        "Email",
        "Gender",
        "DOB",
        "Gym",
        "Registered",
        "Stripe ID",
        "Stripe"
      ];
      const opts = { fields };

      try {
        const parser = new Json2csvParser(opts);
        const csv = parser.parse(userList);
        console.log(csv);
        var csvContent = "data:text/csv;charset=utf-8," + csv;

        window.open(encodeURI(csvContent));
      } catch (err) {
        console.error(err);
      }
    },
    getUsers: function() {
      var _this = this;
      Parse.Cloud.run("getAllUsers")
        .then(results => {
          this.users = results.map(row => row.toJSON());
          this.loading = false;
        })
        .catch( err => {
          alert("ERROR GETTING POST");
        });
    },
    onSubmitWeight: function() {
      this.$router.push("/signup/plan");
    }
  }
};
</script>

<style>
.el-table .cell {
  font-size: 12px;
}
.export-btn {
  position: absolute;
  top: -60px;
  right: 0;
  z-index: 100;
}
.export-btn.lowercase {
  right: 120px;
}
.compliance-box {
  width: 100%;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  height: 160px;
  margin-bottom: 30px;
}
.stat-box {
  width: 100%;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  height: 130px;
}
.stat-box .title {
  font-family: "prohibition";
  font-size: 26px;
  margin-top: 0;
  padding: 10px 20px 0;
  width: 100%;
  text-align: left;
  display: inline-block;
  color: #999999;
  margin-bottom: 0;
}
.stat-box .value {
  color: #d70073;
  font-size: 68px;
  line-height: 68px;
  width: 100%;
  text-align: left;
  padding: 0 20px;
  font-family: "prohibition";
  display: inline-block;
  box-sizing: border-box;
}

.compliance-chart-container {
  width: 100%;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 10px 0;
}
.compliance-row {
  width: 100%;
  display: flex;
  box-sizing: border-box;
  padding: 10px 10px 5px 0;
}
.compliance-row div {
  flex-grow: 1;
}
.compliance-row div.week-title {
  width: 100px;
  text-align: center;
  font-family: prohibition;
  color: #999;
  font-size: 26px;
}

.checkin-marker i {
  background-color: #ccc;
  width: 15px;
  height: 15px;
  margin-top: 10px;
  border-radius: 100%;
  display: inline-block;
}
.checkin-marker.failed i {
  background-color: #eb4c60;
}
.checkin-marker.completed i {
  background-color: #76ce5a;
}
</style>
